import React, { useRef } from "react";

// Import React FilePond
import { FilePond, registerPlugin } from "react-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
// `npm i filepond-plugin-image-preview filepond-plugin-image-exif-orientation --save`
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const ImageUpload = ({ file, setFile }) => {
  const pondRef = useRef(null);

  const handleInit = () => {
    console.log("FilePond instance has initialised", pondRef.current);
  };

  return (
    <FilePond
      ref={pondRef}
      files={file ? [file] : []}
      allowMultiple={false}
      server={{
        process: (fieldName, file, metadata, load) => {
          setTimeout(() => {
            load(Date.now());
          }, 1500);
        },
        load: (source, load) => {
          fetch(source)
            .then((res) => res.blob())
            .then(load);
        },
      }}
      acceptedFileTypes={["image/png", "image/jpeg", "image/jpg"]}
      oninit={handleInit}
      onupdatefiles={(fileItems) => {
        setFile(fileItems.length > 0 ? fileItems[0].file : null);
      }}
    />
  );
};

export default ImageUpload;
